import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import InputControlMask from './InputControlMask';
import '../../css/controls/input.css';


const Input = ({ 
        id, 
        field='',
        label, 
        type = 'text',
        placeholder='', 
        value='', 
        classNameContainer = '',
        classNameInput = '',
        cssClassLabel = '',
        onChange=()=>'',
        mask = '',
        pattern=undefined, 
        title='',
        required=true,
        icon=undefined,
        info='',
        visible=true,
        readOnly=false,
        min
    }) => {

    const cssClassContainer = `${classNameContainer} sg-input mt-15`;
    const cssClassInput = `${classNameInput} sg-input-field`; 
    const cssClassTextArea = `${classNameInput} sg-textarea-field`; 

    const visibleInput = visible ? 'sg-input-visible' : 'sg-input-hidden';
        
    const control = {
        textarea: <textarea 
                rows={2}
                id={id}
                name={field}     
                onChange={onChange} 
                className={cssClassTextArea}
                type={type} 
                placeholder={placeholder} 
                value={value} 
                required={required}
            ></textarea>,
        text: <input           
            id={id}
            name={field}     
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            placeholder={placeholder} 
            value={value} 
            required={required}
            pattern={pattern}
            title={title}        
            readOnly={readOnly}    
        />,
        email: <input           
            id={id}
            name={field}     
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            placeholder={placeholder} 
            value={value} 
            required={required}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            
        />,
        number: <input           
            id={id}
            name={field}     
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            placeholder={placeholder} 
            value={value} 
            required={required}
            min={min}
        />,
        maskInput:<InputControlMask  
            name={field} 
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            id={id} 
            placeholder={placeholder} 
            value={value} 
            required={required}
            mask={mask} 
            pattern={pattern}
            title={title}
        />
    }

    

    return (
        <div className={`${cssClassContainer} ${visibleInput}`}>
            <label htmlFor={id} className={cssClassLabel}>{label} {icon}          
             {info !=='' && <FaInfoCircle color="#E1E1E1" data-tip={info} data-html={true}/>}  
            </label>
            {
                control[type]               
            }
        </div>
    );
}



export default Input;
